/* eslint-disable import/prefer-default-export */
import { useCallback } from 'react'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { copyDashboard } from 'features/dashboard/asyncThunks'
import { getIncrementalName } from 'utils/dashboardNameUtil'

interface UseDuplicateDashboardProps {
  dashboardId?: string
  dashboardName?: string
}

interface UseDuplicateDashboardResult {
  handleDuplicate: () => Promise<void>
  isDuplicating: boolean
}

export const useDuplicateDashboard = ({
  dashboardId,
  dashboardName
}: UseDuplicateDashboardProps): UseDuplicateDashboardResult => {
  const dispatch = useAppDispatch()
  const isDuplicating = useAppSelector(({ dashboard }) => dashboard.operatingStatus === 'copying')

  const handleDuplicate = useCallback(async () => {
    if (!dashboardId) {
      return
    }

    try {
      await dispatch(
        copyDashboard({
          dashboardId: Number(dashboardId),
          dashboardName: dashboardName ? getIncrementalName(dashboardName) : ''
        })
      ).unwrap()
    } catch (err) {
      console.error('Error duplicating dashboard:', err)
    }
  }, [dashboardId, dashboardName, dispatch])

  return {
    handleDuplicate,
    isDuplicating
  }
}
